import {
    View,
} from 'react-native'
import { globalStyles } from '../../../../static/styles/global'
import HomeDetailsHeader from '../../../home/HomeDetailsHeader'
import { useFormsStore } from '../../../../stores/onboarding'
import { useInitializeStore } from '../../../../stores/initialize'
import { usePersonalStore } from '../../../../stores/personalInfo'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import SignatureFormView from '../../SignatureFormView'

const VowellsInformationOnline = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
        values,
        description
    } = params



    const { loading, postVowellsForm } = useFormsStore((state) => ({
        loading: state.loading,
        postVowellsForm: state.postVowellsForm
    }))
    const initializestore = useInitializeStore()
    const personalstore = usePersonalStore()

    const TODAY = moment().format('MM/DD/YYYY')

    const handleSubmit = async (signatureDataURL: string) => {
        const data = {
            completeOnline: true,
            essUserKey: initializestore.initializeData.userkey,
            entityId: personalstore.personalData?.entityId,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            essObKey: essUserOnBoardingKey,
            ehinitial: values.employeeHandbookInitials.toUpperCase() + "  " + TODAY,
            tvainitial: values.tvAcknowlInitials.toUpperCase() + "  " + TODAY,
            tvahbinitial:
                values.tvAdditionalHBAcknowlInitials.toUpperCase() + "  " + TODAY,
            tvdrinitial: values.tvDrCodeAcknoInitials.toUpperCase() + "  " + TODAY,
            tvtainitial: values.tvTobaccoAlcoholInitials.toUpperCase() + "  " + TODAY,
            sign: signatureDataURL,
        }

        const response = await postVowellsForm(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message || 'Form submitted successfully',
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message || 'Failed to submit form',
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={description || "Vowells Acknowledgement"}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('VowellsInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",
                        description

                    })
                }
                onSubmit={handleSubmit}
                stateValue='VOWELLS'
            />

        </>
    )
}



export default VowellsInformationOnline
